import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RbacService } from '../services/rbac.service';

/** Restricts the file upload route to users with the global ADMIN role. */
export const globalAdminGuard: CanActivateFn = () => {
  const rbacService = inject(RbacService);
  const router = inject(Router);

  return rbacService.isGlobalAdmin() ? true : router.createUrlTree(['/dashboard']);
};
